var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import { cx } from 'emotion';
import * as typographyStyles from './typographyClasses';
import tagnames from './tagnames';

var Typography = function Typography(_a) {
  var type = _a.type,
      as = _a.as,
      forwardedAs = _a.forwardedAs,
      props = __rest(_a, ["type", "as", "forwardedAs"]);

  return React.createElement(forwardedAs || as || tagnames[type], __assign(__assign({}, props || {}), {
    className: cx(typographyStyles[type], props && props.className)
  }));
};

Typography.defaultProps = {
  type: 'caption',
  as: undefined
};
export default Typography;